export const isUATorStaging = window.location.hostname.includes("rideminder.uat") || window.location.hostname.includes("cod.staging");
